// interfaces
import { IGlobalProfiles } from 'src/interfaces/profiles_list'

export const $globalProfiles = (json: IGlobalProfiles): IGlobalProfiles => {
  return json
}
